import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { setupAgTestIds } from "ag-grid-community";

if (environment.production) {
  enableProdMode();
} 
if(window.location.hostname != "srs.edtell.com") {
  console.log("Setting up ag-grid test IDs");
  setupAgTestIds();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
